import { render } from "./CustomPage.vue?vue&type=template&id=2e1a4053"
import script from "./CustomPage.vue?vue&type=script&lang=js"
export * from "./CustomPage.vue?vue&type=script&lang=js"

import "./CustomPage.vue?vue&type=style&index=0&id=2e1a4053&lang=scss"

import exportComponent from "/root/Fnedu/build/build20250805.141732/dashboard/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__